import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'matriculas': [],
  'matriculasHistory': [],
  'loading': false,
};

export const wtsMatriculas = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_MATRICULAS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_MATRICULAS]: (state, action) => ({
      ...state,
      'loading': false,
      'matriculas': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_MATRICULAS_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'matriculas': [],
    }),
    [ActionTypes.CREATING_WTS_MATRICULAS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_MATRICULAS]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_MATRICULAS_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_WTS_MATRICULA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_MATRICULA]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_MATRICULA_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_WTS_MATRICULAS_HISTORY]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_MATRICULAS_HISTORY]: (state, action) => ({
      ...state,
      'loading': false,
      'matriculasHistory': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_MATRICULAS_HISTORY_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'matriculasHistory': [],
    }),
  })(state, action);
};
